import { useEffect, useState } from "react";
import { X, Info, CheckCircle2, AlertTriangle, AlertOctagon } from "lucide-react";
import { api } from "@/lib/api";

const TONE = {
  INFO: { cls: "border-blue-200 bg-blue-50 text-blue-900", Icon: Info },
  SUCCESS: { cls: "border-emerald-200 bg-emerald-50 text-emerald-900", Icon: CheckCircle2 },
  WARNING: { cls: "border-amber-200 bg-amber-50 text-amber-900", Icon: AlertTriangle },
  CRITICAL: { cls: "border-rose-200 bg-rose-50 text-rose-900", Icon: AlertOctagon },
};

/** Platform announcements targeted at this tenant, shown above the page body. */
export default function AnnouncementBanner() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api
      .get("/announcements")
      .then(({ data }) => setRows(data))
      .catch(() => setRows([]));
  }, []);

  const dismiss = async (id) => {
    setRows((r) => r.filter((a) => a.id !== id));
    try {
      await api.post(`/announcements/${id}/dismiss`);
    } catch {
      /* a failed dismiss just means it reappears next load */
    }
  };

  if (!rows.length) return null;

  return (
    <div className="space-y-2" data-testid="announcement-banners">
      {rows.map((a) => {
        const { cls, Icon } = TONE[a.level] || TONE.INFO;
        return (
          <div
            key={a.id}
            className={`flex items-start gap-3 rounded-md border px-4 py-3 ${cls}`}
            data-testid={`announcement-banner-${a.id}`}
          >
            <Icon size={16} className="mt-0.5 shrink-0" />
            <div className="min-w-0 flex-1">
              <div className="text-sm font-semibold">{a.title}</div>
              <div className="mt-0.5 whitespace-pre-wrap text-xs opacity-90">{a.body}</div>
            </div>
            {a.is_dismissible && (
              <button
                onClick={() => dismiss(a.id)}
                data-testid={`announcement-dismiss-${a.id}`}
                className="shrink-0 opacity-60 transition-opacity duration-150 hover:opacity-100"
                title="Dismiss"
              >
                <X size={15} />
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
